import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.div`
  height: calc(100vh - 83px);
  overflow: auto;
  scroll-snap-type: y mandatory;
  scroll-padding-bottom: 70px;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    height: calc(100vh - 156px);
  }
`;
